import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const TextContainer = styled.div`

h2 {
  ${Font.clarinVarSub2Regular};
  font-size: 21px;
  line-height: 26px;
  color: ${Color.grey};
  padding-top: 8px;
  margin-bottom: 50px;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
    color:  ${ColorDark.textLight};
    }
  }
  ${breakpoints.phone} {
    font-size: 17px;
    line-height: 23px;
  }
    }
`

export const HoroscopeDetailContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .button-redirect {
    ${Font.sansRegular};
    background-color: ${Color.greyF5F5F5};
    border-radius: 50px;
    border: none;
    color: ${Color.black000};
    cursor: pointer;
    font-size: 13px;
    padding: 13px 0px;
    text-align: center;
    text-decoration: none;
    width: 125px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      color:  ${ColorDark.textLight};
      }
    }
    &:hover {
      background-color: ${Color.mainColor};
      color: ${Color.white};
    }
  }
  .horoscope-detail-sign-container {
    width: 100%;
    border-bottom: 1px solid ${Color.greySeparator};
    padding-top: 8px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom:1px solid ${ColorDark.greySeparator};
      }
    }
    .horoscope-detail-sign {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 5px;
      width: 100%;
      padding: 16px 0px 5px;
      .horoscope-detail-image {
        background-color: ${Color.white};
        border-radius: 50px;
        width: 105px;
        height: 105px;
      }
      .horoscope-detail-name {
        ${Font.sansBold};
        font-size: 28px;
        line-height: 24px;
        color: ${Color.black000};
        text-align: center;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color:  ${ColorDark.textLight};
          }
        }
      }
      .horoscope-detail-date {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 10px;
        .horoscope-detail-years {
          text-align: center;
          line-height: 20px;
          ${Font.sansRegular};
          font-size: 16px;
          line-height: 22px;
          color: ${Color.black000};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color:  ${ColorDark.textLight};
            }
          }
          ${breakpoints.phone} {
            width: 85%;
          }
        }
        .horoscope-detail-since,
        .horoscope-detail-until {
          ${Font.sansRegular};
          font-size: 16px;
          line-height: 20px;
          color: ${Color.black000};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color:  ${ColorDark.textLight};
            }
          }
        }
      }
      .astrology-today {
        ${Font.sansRegular};
        background-color: ${Color.greyF5F5F5};
        border-radius: 50px;
        border: none;
        color: ${Color.black000};
        cursor: pointer;
        font-size: 13px;
        margin-bottom: 35px;
        margin-top: 30px;
        padding: 13px 0px;
        text-align: center;
        text-decoration: none;
        //width: 90px;
        padding: 13px 15px;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          background-color:${ColorDark.greySeparator};
            color:${ColorDark.textLight};
          }
          
        }
        &:hover {
          background-color: ${Color.mainColor};
          color: ${Color.white};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            background-color:${ColorDark.mainColor};
            }
          }
        }
        ${breakpoints.phone} {
          margin-bottom: 0px;
        }
      }
      .astrology-day {
        display: inline-flex;
        li {
          margin: 0 10px 0 10px;
        }
        ${breakpoints.phone} {
          display: block;
        }
      }
      .astrology-today {
        &.checked{
          background-color: ${Color.mainColor};
          color: ${Color.white};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color:  ${Color.white};
            background-color: ${ColorDark.mainColor};
            }

          }
          
        }
      }
    }
    .horoscope-detail-content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 24px;
      width: 100%;
      margin: 0px 0px 32px;
      .horoscope-detail-content-text {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: 70%;
        gap: 8px;
        ${breakpoints.phone} {
          width: 90%;
        }
        .black-sign{
          font-weight: 700;
          font-variation-settings: normal;
      }
        .horoscope-detail-content-title {
          ${Font.clarinVarSub2Bold};
          font-size: 23px;
          line-height: 21px;
          color: ${Color.black000};
          text-align: center;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color:  ${ColorDark.textLight};
            }
          }
          ${breakpoints.phone} {
            font-size: 20px;
            align-self: flex-start;
          }
        }
        .chinese-title{
          margin-bottom: 15px;
        }
        .horoscope-detail-content-description {
          ${Font.clarinVarSub2Regular};
          font-size: 23px;
          line-height: 33px;
          color: ${Color.black000};
          text-align: center;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color:  ${ColorDark.textLight};
            }
          }
          & .chinese {
            margin-bottom: 15px;
          }              
          ${breakpoints.phone} {
            font-size: 20px;
            text-align: left;
          }
        }
        .chinese {
          .horoscope-detail-content-description {
            margin-bottom: 15px;
          }
        }
      }
      .horoscope-detail-content-description-container {
        width: 60%;
        ${breakpoints.phone} {
          width: 95%;
        }
        p {
          ${Font.clarinVarSub2Regular};
          font-size: 23px;
          line-height: 33px;
          color: ${Color.black000};
          text-align: center;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color:  ${ColorDark.textLight};
            }
          }
          ${breakpoints.phone} {
            font-size: 20px;
            text-align: left;
          }
        }
      }
      .written-by {
        line-height: 20px;
        ${Font.sansRegular};
        font-size: 16px;
        line-height: 22px;
        color: ${Color.grey};
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color:  ${ColorDark.textLight};
          }
        }
        margin-bottom: 22px;
        ${breakpoints.phone} {
          text-align: center;
        }
      }
    }
    .horoscope-detail-share {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 64px;
      ${breakpoints.phone} {
        justify-content: flex-start;
        padding-left: 16px;
      }
      .SocialMedia {
        justify-content: center;
        ${breakpoints.phone} {
          justify-content: left;
        }
      }
      .socialContainer {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        li {
          list-style: none;
          a {
            text-decoration: none;
            color: ${Color.grey};
            border-radius: 50%;
            width: 35px;
            height: 35px;
            border: 1px solid ${Color.grey};
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            &:hover {
              background-color: ${Color.grey};
              svg {
                fill: ${Color.white};
              }
            }
            svg {
              width: 20px;
              height: 20px;
              fill: ${Color.grey};
            }
          }
        }
      }
    }
  }
`;
